import { gql } from '@apollo/client';

export const UPDATE_VERIFICATION_TYPE = gql`
  mutation updateVerificationType($input: UpdateVerificationTypeInput) {
    updateVerificationType(input: $input) {
      commandId
    }
  }
`;

export const TEST_VERIFICATION_FORMULA = gql`
  mutation testVerificationFormula($input: TestVerificationFormula) {
    testVerificationFormula(input: $input) {
      commandId
      correlationId
    }
  }
`;
